import { nonAccentVietnamese } from "./TextFields";

export class DOCSO {
    static t = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
        
    static r (r, n) {
        var o = "",
            a = Math.floor(r / 10),
            e = r % 10;
        return a > 1 ? (o = " " + this.t[a] + " mươi", 1 == e && (o += " mốt")) : 1 == a ? (o = " mười", 1 == e && (o += " một")) : n && e > 0 && (o = " lẻ"), 5 == e && a >= 1 ? o += " lăm" : 4 == e && a >= 1 ? o += " bốn" : (e > 1 || 1 == e && 0 == a) && (o += " " + this.t[e]), o
    }

    static number (n, o) {
        var a = "",
            e = Math.floor(n / 100);
        n = n % 100;
        return o || e > 0 ? (a = " " + this.t[e] + " trăm", a += this.r(n, !0)) : a = this.r(n, !1), a
    }

    static o (t, r) {
        var o = "",
            a = Math.floor(t / 1e6);
        t = t % 1e6;
        a > 0 && (o = this.number(a, r) + " triệu", r = !0);
        var e = Math.floor(t / 1e3);
        t = t % 1e3;
        return e > 0 && (o += this.number(e, r) + " nghìn", r = !0), t > 0 && (o += this.number(t, r)), o
    }

    static doc(r, unit = undefined) {
        var currencyUnit = getCurrencyUnit(unit);
        if (0 == r) return this.t[0] + currencyUnit;
        var n = "", a = "", s = "";
        var old = r;
        r = parseInt(r);
        do  { 
            let ty = r % 1e9; 
            r = Math.floor(r / 1e9);
            n = r > 0 ? this.o(ty, !0) + a + n : this.o(ty, !1) + a + n;
            a = " tỷ";
        } while (r > 0);

        if (n.trim() != "") s = n.trim() + currencyUnit;
        //read decimal
        s += readCurrencyDecimal(old, currencyUnit);

        return s.charAt(0).toUpperCase() + s.slice(1);
    }   

    static docEn(s, unit = undefined) {
        var th = ['', 'thousand', 'million', 'billion', 'trillion'];
        var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        s = s.toString();
        s = s.replace(/[\, ]/g, '');
        if (s != parseFloat(s)) return 'not a number';
        var x = s.indexOf('.');
        if (x == -1)
            x = s.length;
        if (x > 15)
            return 'too big';
        var n = s.split('');
        var str = '';
        var sk = 0;
        for (var i = 0; i < x; i++) {
            if ((x - i) % 3 == 2) {
                if (n[i] == '1') {
                    str += tn[Number(n[i + 1])] + ' ';
                    i++;
                    sk = 1;
                } else if (n[i] != 0) {
                    str += tw[n[i] - 2] + ' ';
                    sk = 1;
                }
            } else if (n[i] != 0) { // 0235
                str += dg[n[i]] + ' ';
                if ((x - i) % 3 == 0) str += 'hundred ';
                sk = 1;
            }
            if ((x - i) % 3 == 1) {
                if (sk)
                    str += th[(x - i - 1) / 3] + ' ';
                sk = 0;
            }
        }

        if (str == "") str += " zero "
        str += getCurrencyUnitEN(unit);

        if (x != s.length) {
            str += ' and ';
            var decimal = this.docEn(s.substring(parseInt(x) + 1, s.length) + (s.substring(parseInt(x) + 1, s.length).length == 1 ? "0" : ""))
            var strtmp = decimal.replace(getCurrencyUnitEN(unit), '');
            str += strtmp.replace(/\s+/g, ' ').charAt(0).toLowerCase() + strtmp.slice(1) + ' cents';
        }

        str = str.replace(/\s+/g, ' ');
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    
}

function getCurrencyUnit(unit:any) {
    var currencyUnit = "";
    if (unit != undefined) {
        switch (unit) {
            case "USD":
                currencyUnit = " đô la Mỹ";
                break;
            case "EUR":
                currencyUnit = " Euro";
                break;
            case "AUD":
                currencyUnit = " đô la Úc";
                break;
            case "GBP":
                currencyUnit = " Bảng Anh";
                break;
            case "SGD":
                currencyUnit = " đô la Singapore";
                break;
            case "ZND":
                currencyUnit = " đô la New Zealand";
                break;
            case "JPY":
                currencyUnit = " đồng yên Nhật";
                break;
            case "VND":
                currencyUnit = " đồng";
                break;
            case "CAD":
                currencyUnit = " đô la Canada";
                break;
            case "CHF":
                currencyUnit = " Franc Thụy Sĩ";
                break;
            default:
                currencyUnit = unit == "-1" ? "" : " " + unit;
        }
    }
    return currencyUnit;
}

function getCurrencyUnitEN (unit:any) {
    var currencyUnit = "";
    if (unit != undefined) {
        switch (unit) {
            case "USD":
                currencyUnit = " US dollars";
                break;
            case "EUR":
                currencyUnit = " euros";
                break;
            case "AUD":
                currencyUnit = " Australian dollars";
                break;
            case "GBP":
                currencyUnit = " British pounds";
                break;
            case "SGD":
                currencyUnit = " Singapore dollars";
                break;
            case "ZND":
                currencyUnit = " New Zealand dollars";
                break;
            case "JPY":
                currencyUnit = " Japanese yen";
                break;
            case "VND":
                currencyUnit = " Vietnamese dong";
                break;
            case "CAD":
                currencyUnit = " Canadian dollars";
                break;
            case "CHF":
                currencyUnit = " Swiss franc";
                break;
            default:
                currencyUnit = unit == "-1" ? "" : " " + nonAccentVietnamese(unit);
        }
    }
    return currencyUnit;
}

function readCurrencyDecimal (r, currencyUnit) {
    var s = "";
    if (r != undefined) {
        var tmp = r.toString().split('.')[1];
        var decimal = (tmp != undefined && tmp.length == 1) ? tmp + "0" : tmp;
        if (decimal != undefined) {
            s += " lẻ ";            
            var d = DOCSO.doc(decimal).replace(currencyUnit, '');
            s += d.toLowerCase();
            if (decimal.length == 1)

                s += " mươi "
            s += " xu";
        }
    }

    return s;
}